import { useQuery } from "@tanstack/react-query";
import { authGetRequest } from "../api/authClient";
import type { ModulePermissions } from "../permissions/modulePermissions";
import { normalizeModulePermissions } from "../permissions/modulePermissions";

export interface ModuleConfigData {
  clientId: string;
  applicationId: string;
  modules: ModulePermissions;
  version: number;
}

export function useModuleConfig(
  applicationId: string | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["module-config", applicationId],
    queryFn: async (): Promise<ModuleConfigData> => {
      if (!applicationId) {
        throw new Error("applicationId is required");
      }
      const res = await authGetRequest(
        `/client/auth/module-config?applicationId=${encodeURIComponent(applicationId)}`,
      );
      const data = (res as { data?: ModuleConfigData })?.data ?? (res as ModuleConfigData);
      return {
        clientId: String(data?.clientId ?? ""),
        applicationId: String(data?.applicationId ?? applicationId),
        modules: normalizeModulePermissions(data?.modules ?? data),
        version: Number(data?.version ?? 0),
      };
    },
    enabled: Boolean(applicationId) && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
